module.exports = __webpack_public_path__ + "static/domain-whois_3-ddcebbbe4ee8b749307cb6f2adae5f01.jpg";